import styled from "styled-components";
import {ReactComponent as Stars} from "images/starsGroup.svg";

export const StarsContainer = styled(Stars)``

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 1rem;
    
  .screenTitle {
    display: flex;
    font-size: var(--typography-h5-size);
    line-height: 133.4%;
    font-weight: 600;
  }

  .screenDescription {
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    letter-spacing: 0.15px;
  }

  .screenError {
    color: var(--error-main, #D32F2F);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
    letter-spacing: 0.15px;
    min-height: 2rem;
  }
`
